"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const initializeCookies = () => new universal_cookie_1.default();
exports.default = initializeCookies;
//# sourceMappingURL=initialize.js.map